import { useTranslation } from 'react-i18next'
import { formatDistanceToNow } from 'date-fns'
import { getDateLocale } from '@/utils/dateLocale'
import type { AdminMessageListItem } from '../types/message'

interface MessageListProps {
  messages: AdminMessageListItem[]
  onSelect: (id: number) => void
}

export function MessageList({ messages, onSelect }: MessageListProps) {
  const { t } = useTranslation('messages')

  const getRecipientTypeLabel = (type: string) => {
    switch (type) {
      case 'all': return t('list.recipientType.all')
      case 'department': return t('list.recipientType.department')
      case 'individual': return t('list.recipientType.individual')
      default: return type
    }
  }

  if (messages.length === 0) {
    return (
      <div className="text-center py-10 text-gray-500">
        {t('list.empty')}
      </div>
    )
  }

  return (
    <div className="divide-y divide-gray-200">
      {messages.map((message) => (
        <div
          key={message.id}
          onClick={() => onSelect(message.id)}
          className="p-4 hover:bg-gray-50 cursor-pointer"
        >
          <div className="flex justify-between items-start">
            <div className="flex-1">
              <h3 className="font-medium text-gray-900">{message.title}</h3>
              <p className="text-sm text-gray-500 mt-1">
                {t('list.recipient', { type: getRecipientTypeLabel(message.recipientType), count: message.totalRecipients })}
              </p>
            </div>
            <div className="text-right">
              <p className="text-sm text-gray-500">
                {formatDistanceToNow(new Date(message.createdAt), {
                  addSuffix: true,
                  locale: getDateLocale()
                })}
              </p>
              <p className="text-sm mt-1">
                <span className={message.readCount === message.totalRecipients ? 'text-green-600' : 'text-gray-600'}>
                  {t('list.readCount', { read: message.readCount, total: message.totalRecipients })}
                </span>
                {message.readCount === message.totalRecipients && ' ✓'}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
